import OpenAI from "openai";

export class OpenAIApi {
	public getOpenAITranslations = async (
		prompt: string
	): Promise<any> => {
		const openai = new OpenAI({
			apiKey: process.env.REACT_APP_OPENAI_API_KEY,
			dangerouslyAllowBrowser: true,
		});
		try {
			const response = await openai.chat.completions.create({
				model: "gpt-4o-mini",
				messages: [{ role: "user", content: prompt }],
			});
			let responseContent = response.choices[0].message.content!.trim();

			return responseContent;
		} catch (error) {
			console.error("Error fetching suggestions from OpenAI:", error);
			throw error;
		}
	};
}
